export default function getCurrentDatetime() {
  return new Date();
}